import { Component, ViewEncapsulation, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { ModelsService, BlendedResult} from '@irb/irb-models//models-new/models.service';
import {IrbAppEvents, IrbModelsEvents} from '@irb-common/events';
import { UtilityService } from '@irb-common/services/utility.service';

@Component({ standalone: false,
  selector: 'irb-import-blended-models-dialog',
  templateUrl: './import-blended-models-dialog.component.html',
  styleUrls: ['./import-blended-models-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportBlendedModelsDialogComponent implements OnInit {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string ;
  resultDatas:BlendedResult[] =[];
  progressTimer: any;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<ImportBlendedModelsDialogComponent>,
    public as: AppService,
    public modelsService: ModelsService,
    private util: UtilityService
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
      this.file = event.target.files[0];
      this.hasFile = this.isValidFile = true;
      if (!this.file.name.endsWith('.csv')) {
          this.isValidFile = false;
          this.invalidFileErrorHeader = "Invalid file format.";
          this.invalidFileErrorMessage = "Extension type must be \".csv\"";
      }
      if (this.as.maxFileUploadSizeExceeded(this.file)) {
          this.triggerMaxFileUploadSizeExceededError();
      }
    this.errorMessage = "";
  }

    private triggerMaxFileUploadSizeExceededError() {
        this.isValidFile = false;
        this.invalidFileErrorHeader = "Invalid file size.";
        this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
    }

  submitFile() {
    const f = new FormData();
    f.append('ImportModel', this.file, this.file.name);

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.modelsService.validateImportedBlendedModelsAsynch(f).subscribe((response: any) => {
      if (this.progressTimer) clearTimeout(this.progressTimer);
      if (response.responseStatus === "SUCCESS" && response.responseUtilityMap)
        this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.modelsService.validateImportedBlendedModelsStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const responseData = statusResponse.responseData;
        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.reqStatus) {
          reqStatus = statusResponse.responseUtilityMap.reqStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = this.isUiTest ? 0 : 1500;
          this.progressTimer = setTimeout(() => {
            this.actionStatusCheckIntervalStart(statusId);
          }, timeout);
        }

        if (reqStatus === 'COMPLETED') {
          this.validateImportBlendedModelsProcess(responseData);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if (this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    });
  }

  validateImportBlendedModelsProcess(res: any) {
    //const response = JSON.parse(res);
    const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));
    if (response && response.responseStatus && response.responseStatus === 'BUSINESS_ERR_MSG') {
      this.triggerMaxFileUploadSizeExceededError();
    } else {

      if (response.status && response.status === "fail") {
        if (response.message) {
          this.errorMessage = response.message;
        } else {
          this.isValidFile = false;
        }
        return;
      }
      if (response.message === "Invalid file format"){
        this.errorMessage ="Use our .csv template to prepare your file.";
        return;
      }

      const newValidRecords = (response.newValidRecords && response.newValidRecords.length > 0);
      const invalidRecords = (response.invalidRecords && response.invalidRecords.length > 0);
      const existingValidRecords = (response.existingValidRecords && response.existingValidRecords.length > 0);

      if(response.existingRecords && response.existingRecords.length > 0){
        for (const name of response.existingRecords) {
          const resultData  = {} as BlendedResult;
          resultData.name = name;
          resultData.status = "Exists as an blended security model";
          resultData.action = "will be OVERWRITTEN";
          this.resultDatas.push(resultData);
        }
      }
      if(response.newRecords && response.newRecords.length > 0){
        for (const name of response.newRecords) {
          const resultData  = {} as BlendedResult;
          resultData.name = name;
          resultData.status = "New blended model";
          resultData.action = "will be added";
          this.resultDatas.push(resultData);
        }
      }
      response.resultDatas = this.resultDatas;

      if(invalidRecords){
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS_ERROR, response);
      } else if(newValidRecords || existingValidRecords) {
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS_RESULT, response);
      }
      this.close();
    }
  }
}
